import Button from "devextreme-react/button";
import { confirm } from "devextreme/ui/dialog";
import { useContext, useEffect } from "react";
import { useNavigate, useSearchParams } from "react-router-dom";
import { LoadPagePanel } from "../../../../components";
import { AR } from "../../../../types/enums";
import { showErrorMessage, showSuccessMessage } from "../../../../utils/messages";
import { useApproveCancellation } from "../api/approve-cancellation";
import { PurchaseOrderContext } from "../context/PurchaseOrderContext";

export default function ApproveCancellationButton() {

	const { order, refetchOrder } = useContext(PurchaseOrderContext);

	const [searchParams, setSearchParams] = useSearchParams();
	let isApprove = searchParams.get("Cancel") === "1";

	const rejectCancellation = useApproveCancellation(order.details.purchaseOrderID,
		() => {
			if (searchParams.has('Cancel')) {
				searchParams.delete('Cancel');
				setSearchParams(searchParams);
			}
			showSuccessMessage('Cancellation has been approved');
			refetchOrder();
		},
		(error) => showErrorMessage(error));

	useEffect(() => {
		if (isApprove) {
			if (!order.details.activeARs.includes(AR.PODistributorToApproveCancelation)) {
				searchParams.delete('Cancel');
				setSearchParams(searchParams);
				showErrorMessage("The order is not pending cancellation");
			}
			else {
				confirm("Are you sure you want to approve cancellation?",
					"Approve Cancellation")
					.then(result => {
						if (result) {
							rejectCancellation.mutate();
						}
					});
			}
		}
	}, [isApprove]);

	return (
		<>
			<Button elementAttr={{ 'data-testid': 'btn-reject-cancellation' }}
				text="Approve Cancellation"
				icon="Inscyth-Confirm"
				visible={order.details.activeARs.includes(AR.PODistributorToApproveCancelation)}
				disabled={rejectCancellation.isLoading}
				onClick={() => {
					confirm("Are you sure you want to approve cancellation?",
						"Approve Cancellation")
						.then(result => {
							if (result) {
								rejectCancellation.mutate();
							}
						});
				}} >
			</Button>
			<LoadPagePanel visible={rejectCancellation.isLoading}></LoadPagePanel>
		</>
	)
}
